window.RITE_QUIZZES = {
  version: 1,
  hub: {
    kicker: "RITE Tests",
    title: "Find out who you are. Then read them.",
    sub: "A compass, a philosopher match, then the longer values surveys. Each result points at books in the catalog."
  },
  quizzes: [
    {
      id: "political-compass",
      handle: "political-compass",
      title: "The RITE Compass",
      kicker: "20 questions · 4 min",
      blurb: "Not left-right. Two axes: economic and authority. You get a point on the chart, a figure who sat near it, and the books they actually wrote.",
      featured: true,
      home: true,
      status: "live",
      type: "compass",
      likert: [
        { label: "Strongly disagree", v: -2 },
        { label: "Disagree", v: -1 },
        { label: "Agree", v: 1 },
        { label: "Strongly agree", v: 2 }
      ],
      questions: [
        { text: "The state should own the commanding heights of industry — energy, rail, banks, steel.", axis: "econ", dir: -1 },
        { text: "A man should keep what he earns, even when the gap with his neighbor gets ugly.", axis: "econ", dir: 1 },
        { text: "Inheritance is a civilized way of handing a family's work to the next generation.", axis: "econ", dir: 1 },
        { text: "Rent, interest, and most profit are extraction dressed up as enterprise.", axis: "econ", dir: -1 },
        { text: "Price controls on bread and rent are usually wiser than leaving them to the market.", axis: "econ", dir: -1 },
        { text: "A union that can shut a workplace down is a healthy check on owners.", axis: "econ", dir: -1 },
        { text: "Private property in land is a foundation of order, not a historical accident.", axis: "econ", dir: 1 },
        { text: "Equality of outcome is a just political goal, not a jealous one.", axis: "econ", dir: -1 },
        { text: "Some speech is too dangerous to allow in public, even from serious people.", axis: "auth", dir: 1 },
        { text: "A people needs a strong hand more than another round of voting.", axis: "auth", dir: 1 },
        { text: "Conscription is a duty. A country that cannot call its sons is already finished.", axis: "auth", dir: 1 },
        { text: "The family, not the unattached individual, is the basic unit of a society.", axis: "auth", dir: 1 },
        { text: "Drug laws are the state pretending it owns your body.", axis: "auth", dir: -1 },
        { text: "Police and army should be small, visible, and tightly limited.", axis: "auth", dir: -1 },
        { text: "Tradition is usually wiser than last decade's reformers.", axis: "auth", dir: 1 },
        { text: "A man owes nothing to a country that will not leave him alone.", axis: "auth", dir: -1 },
        { text: "War is sometimes the health of a nation.", axis: "auth", dir: 1 },
        { text: "Borders are a moral fact, not a bureaucratic inconvenience.", axis: "auth", dir: 1 },
        { text: "Experts and commissions should run more of daily life. Voters are tired and sloppy.", axis: "auth", dir: 1 },
        { text: "If a company can pay a man less than it takes to live, the company should not exist.", axis: "econ", dir: -1 }
      ],
      figures: [
        { id: "lenin", name: "Vladimir Lenin", years: "1870–1924", econ: -7.2, auth: 7.4, ideology: "Authoritarian left", blurb: "You want the economy seized and the party to hold the gun while it happens. Lenin called that the dictatorship of the proletariat and then built the apparatus to make it stick.", books: ["state-and-revolution-revised", "foundations-of-leninism", "the-communism-bundle", "philosophy-of-marx"] },
        { id: "stalin", name: "Joseph Stalin", years: "1878–1953", econ: -6.0, auth: 9.0, ideology: "Authoritarian left", blurb: "You don't just want the left to win. You want it administered. Five-year plans, cadres, and no patience for people who treat politics as a seminar.", books: ["foundations-of-leninism", "the-communism-bundle", "state-and-revolution-revised"] },
        { id: "goldman", name: "Emma Goldman", years: "1869–1940", econ: -7.0, auth: -6.4, ideology: "Libertarian left", blurb: "You hate capital and you also hate the commissar. The state is not a tool you trust, even when it speaks for the workers.", books: ["anarchism-and-other-essays", "philosophy-of-marx"] },
        { id: "marx", name: "Karl Marx", years: "1818–1883", econ: -8.2, auth: 1.6, ideology: "Economic left", blurb: "You read history as class struggle and property as a relation, not a sacrament. You are less interested in the police than in who owns the mill.", books: ["philosophy-of-marx", "communist-manifesto-revised", "the-communism-bundle"] },
        { id: "nietzsche", name: "Friedrich Nietzsche", years: "1844–1900", econ: 1.8, auth: -5.2, ideology: "Libertarian right-of-center", blurb: "You don't want a program. You want rank, style, and a self that isn't borrowed. The herd — left or right — is the enemy.", books: ["beyond-good-and-evil", "thus-spake-zarathustra-a-book-for-all-and-none", "on-the-genealogy-of-morals-and-ecce-homo", "the-nietzsche-bundle"] },
        { id: "evola", name: "Julius Evola", years: "1898–1974", econ: 2.6, auth: 7.2, ideology: "Authoritarian right", blurb: "You don't argue from GDP. You argue from caste, rite, and the idea that modernity is a spiritual climate to be ridden, not reformed.", books: ["revolt-against-the-modern-world-politics-religion-and-social-order-in-the-kali-yuga", "ride-the-tiger-a-survival-manual-for-the-aristocrats-of-the-soul", "men-among-the-ruins-postwar-reflections-of-a-radical-traditionalist", "the-essential-evola-bundle"] },
        { id: "yockey", name: "Francis Parker Yockey", years: "1917–1960", econ: 3.8, auth: 8.0, ideology: "Authoritarian right", blurb: "Culture as organism, the West as a subject, politics as destiny. You have little use for the parliamentary manner.", books: ["imperium-the-philosophy-of-history-and-politics", "the-francis-p-yockey-bundle"] },
        { id: "guenon", name: "René Guénon", years: "1886–1951", econ: 1.4, auth: 4.8, ideology: "Traditionalist", blurb: "You think the modern world is a metaphysical error. Politics is downstream of initiation, caste, and a knowledge that isn't in the newspapers.", books: ["the-crisis-of-the-modern-world"] },
        { id: "aurelius", name: "Marcus Aurelius", years: "121–180", econ: 0.6, auth: 2.2, ideology: "Center, ordered", blurb: "Duty, inner rule, a state that holds. You are not a radical. You are the man who still has to govern himself while the empire wobbles.", books: ["meditations-complete-and-unabridged"] },
        { id: "jung", name: "Carl Jung", years: "1875–1961", econ: 0.2, auth: -1.8, ideology: "Center, inward", blurb: "You treat politics as a symptom. The real map is the psyche — shadow, self, the figures that live in you whether you vote or not.", books: ["modern-man-in-search-of-a-soul", "psychology-of-the-unconscious", "red-book-a-reader-s-edition", "the-carl-jung-bundle"] },
        { id: "spengler", name: "Oswald Spengler", years: "1880–1936", econ: 2.2, auth: 5.4, ideology: "Civilizational right", blurb: "Cultures are living forms with youth and old age. You read the present as a late season, not a policy failure.", books: ["decline-of-the-west-two-volumes-in-one", "the-spengler-bundle"] },
        { id: "gaddafi", name: "Muammar Gaddafi", years: "1942–2011", econ: -3.4, auth: 6.2, ideology: "Third position", blurb: "Neither Moscow nor the market. You want a system that talks like a people and rules like a state.", books: ["gaddafi-s-the-green-book"] }
      ]
    },
    {
      id: "which-philosopher-are-you",
      handle: "which-philosopher-are-you",
      title: "Which philosopher are you?",
      kicker: "10 questions · 3 min",
      blurb: "Not a costume. A temperament. Nietzsche, Evola, Jung, Marx, Aurelius, Kierkegaard, Guénon — then the editions we actually stock.",
      home: true,
      status: "live",
      type: "scored",
      questions: [
        {
          text: "A civilization dies first in which place?",
          choices: [
            { label: "In its religion and rites.", scores: { evola: 2, guenon: 2, spengler: 1 } },
            { label: "In its economy — who owns the mill.", scores: { marx: 3 } },
            { label: "In the soul of the last serious men.", scores: { nietzsche: 2, kierkegaard: 1, jung: 1 } },
            { label: "When the people forget how to command themselves.", scores: { aurelius: 3, evola: 1 } }
          ]
        },
        {
          text: "You open a book at night because you want:",
          choices: [
            { label: "A diagnosis of your own interior.", scores: { jung: 3, kierkegaard: 1 } },
            { label: "A weapon.", scores: { marx: 2, evola: 1, nietzsche: 1 } },
            { label: "A standard you can actually live by tomorrow.", scores: { aurelius: 3 } },
            { label: "Contact with something older than the modern world.", scores: { guenon: 3, evola: 2 } }
          ]
        },
        {
          text: "Morality is mostly:",
          choices: [
            { label: "A story the weak told about the strong.", scores: { nietzsche: 3 } },
            { label: "A residue of revelation and caste.", scores: { guenon: 2, evola: 2 } },
            { label: "A mask over class interest.", scores: { marx: 3 } },
            { label: "The inner law a man keeps when no one is watching.", scores: { aurelius: 2, kierkegaard: 2 } }
          ]
        },
        {
          text: "Suffering is:",
          choices: [
            { label: "The material of becoming who you are.", scores: { nietzsche: 2, jung: 2 } },
            { label: "A scandal that faith has to pass through.", scores: { kierkegaard: 3 } },
            { label: "Mostly produced by a system, not a mystery.", scores: { marx: 3 } },
            { label: "To be borne, not advertised.", scores: { aurelius: 3, evola: 1 } }
          ]
        },
        {
          text: "The modern West's deepest error is:",
          choices: [
            { label: "That it thinks it has no unconscious.", scores: { jung: 3 } },
            { label: "That it cut the vertical link — God, caste, initiation.", scores: { guenon: 3, evola: 2 } },
            { label: "That it calls comfort a virtue.", scores: { nietzsche: 2, mishima: 1 } },
            { label: "That it pretends capital is natural law.", scores: { marx: 3 } }
          ]
        },
        {
          text: "If you had to pick a life, it would look like:",
          choices: [
            { label: "A solitary, exacting one. Few friends. High standard.", scores: { kierkegaard: 2, aurelius: 2, nietzsche: 1 } },
            { label: "A public one — speeches, parties, the street.", scores: { marx: 2 } },
            { label: "An aristocratic withdrawal that still judges the age.", scores: { evola: 3, guenon: 1 } },
            { label: "A long descent into the figures that live in you.", scores: { jung: 3 } }
          ]
        },
        {
          text: "Truth arrives as:",
          choices: [
            { label: "A hammer.", scores: { nietzsche: 3 } },
            { label: "A system.", scores: { marx: 2, guenon: 1 } },
            { label: "A symbol you have to sit with.", scores: { jung: 3, guenon: 1 } },
            { label: "A demand on how you live this week.", scores: { kierkegaard: 2, aurelius: 2 } }
          ]
        },
        {
          text: "The body is:",
          choices: [
            { label: "A site of discipline and style.", scores: { nietzsche: 2, evola: 1 } },
            { label: "Mostly a distraction from the real work.", scores: { kierkegaard: 1, guenon: 2 } },
            { label: "Labor power, until it isn't.", scores: { marx: 3 } },
            { label: "The animal you have to govern.", scores: { aurelius: 3, jung: 1 } }
          ]
        },
        {
          text: "When a crowd agrees with you, you:",
          choices: [
            { label: "Check whether you have become cheap.", scores: { nietzsche: 3, kierkegaard: 2 } },
            { label: "Assume the form is finally returning.", scores: { evola: 2, guenon: 1 } },
            { label: "Ask which class just spoke.", scores: { marx: 3 } },
            { label: "Stay at your post. The crowd is weather.", scores: { aurelius: 3 } }
          ]
        },
        {
          text: "Pick the sentence you would underline.",
          choices: [
            { label: "He who has a why can bear almost any how.", scores: { nietzsche: 3 } },
            { label: "The philosophers have only interpreted the world.", scores: { marx: 3 } },
            { label: "Until you make the unconscious conscious, it will direct your life.", scores: { jung: 3 } },
            { label: "The modern world is a rupture, not a development.", scores: { guenon: 2, evola: 2 } }
          ]
        }
      ],
      results: [
        { id: "nietzsche", name: "Friedrich Nietzsche", years: "1844–1900", blurb: "You don't want a catechism. You want a self that isn't borrowed from the last moral fashion. Rank, style, the long work of becoming.", books: ["beyond-good-and-evil", "thus-spake-zarathustra-a-book-for-all-and-none", "on-the-genealogy-of-morals-and-ecce-homo", "the-nietzsche-bundle"] },
        { id: "evola", name: "Julius Evola", years: "1898–1974", blurb: "You read the age as a spiritual climate. Politics is real, but it is downstream of caste, rite, and whether a man can still stand upright in the Kali Yuga.", books: ["revolt-against-the-modern-world-politics-religion-and-social-order-in-the-kali-yuga", "ride-the-tiger-a-survival-manual-for-the-aristocrats-of-the-soul", "the-essential-evola-bundle"] },
        { id: "jung", name: "Carl Jung", years: "1875–1961", blurb: "You treat the interior as a territory. Shadow, self, the figures that arrive uninvited. Politics is a later conversation.", books: ["modern-man-in-search-of-a-soul", "psychology-of-the-unconscious", "red-book-a-reader-s-edition", "the-carl-jung-bundle"] },
        { id: "marx", name: "Karl Marx", years: "1818–1883", blurb: "You keep bringing it back to who owns what. Ideas are not innocent. They have an address in the economy.", books: ["philosophy-of-marx", "communist-manifesto-revised", "the-communism-bundle"] },
        { id: "aurelius", name: "Marcus Aurelius", years: "121–180", blurb: "You want a standard you can keep on a bad Tuesday. Not a system. A posture.", books: ["meditations-complete-and-unabridged"] },
        { id: "kierkegaard", name: "Søren Kierkegaard", years: "1813–1855", blurb: "You are not looking for a crowd. You are looking for a demand that is addressed to you, specifically, and cannot be outsourced to a movement.", books: ["the-sickness-unto-death"] },
        { id: "guenon", name: "René Guénon", years: "1886–1951", blurb: "You think the modern world is a metaphysical mistake. The interesting question is not left or right. It is whether anything vertical is still intact.", books: ["the-crisis-of-the-modern-world"] },
        { id: "spengler", name: "Oswald Spengler", years: "1880–1936", blurb: "You read cultures the way other people read lives: youth, summer, late style, winter. The present is a season.", books: ["decline-of-the-west-two-volumes-in-one", "the-spengler-bundle"] }
      ]
    },
    {
      id: "which-dictator-are-you",
      handle: "which-dictator-are-you",
      title: "Which dictator are you?",
      kicker: "8 questions · 2 min",
      blurb: "A mean little match. Not a costume and not a vote. You get the historical figure your answers rhyme with — and the primary texts, if we stock them.",
      status: "live",
      type: "scored",
      questions: [
        {
          text: "Power is legitimate when it:",
          choices: [
            { label: "Speaks as the people and then does not ask again.", scores: { gaddafi: 2, mussolini: 1 } },
            { label: "Industrializes a backward country on a clock.", scores: { stalin: 3, mao: 1 } },
            { label: "Restores a wounded nation to rank.", scores: { hitler: 3, mussolini: 1 } },
            { label: "Keeps the party as the brain of the class.", scores: { mao: 2, stalin: 2 } }
          ]
        },
        {
          text: "Your instinct in a crisis is to:",
          choices: [
            { label: "Write a little book and make it the constitution.", scores: { gaddafi: 3 } },
            { label: "Name enemies, then move faster than they can.", scores: { hitler: 2, stalin: 2 } },
            { label: "Turn the crowd into a spectacle and ride it.", scores: { mussolini: 3 } },
            { label: "Send the cadres into the countryside.", scores: { mao: 3 } }
          ]
        },
        {
          text: "The economy should be:",
          choices: [
            { label: "Neither communist nor capitalist — a third thing, loudly explained.", scores: { gaddafi: 3, mussolini: 1 } },
            { label: "A war economy even in peacetime.", scores: { stalin: 2, hitler: 2 } },
            { label: "Corporations, syndicates, the state as conductor.", scores: { mussolini: 3 } },
            { label: "Peasants and furnaces, in that order.", scores: { mao: 3 } }
          ]
        },
        {
          text: "You trust:",
          choices: [
            { label: "A small inner circle and nobody else.", scores: { stalin: 3, hitler: 1 } },
            { label: "Your own voice in front of a square.", scores: { mussolini: 2, hitler: 2, gaddafi: 1 } },
            { label: "The masses, once correctly organized.", scores: { mao: 3, gaddafi: 1 } },
            { label: "A doctrine you can print in a pocket edition.", scores: { gaddafi: 2, mao: 2 } }
          ]
        },
        {
          text: "Uniforms, rallies, the whole theater of the state:",
          choices: [
            { label: "Essential. Politics is a style.", scores: { mussolini: 3, hitler: 2 } },
            { label: "Useful, but secondary to the plan.", scores: { stalin: 3 } },
            { label: "A circus you will outdo with tents and green books.", scores: { gaddafi: 3 } },
            { label: "Fine, as long as the villages move.", scores: { mao: 2 } }
          ]
        },
        {
          text: "History will remember you as:",
          choices: [
            { label: "The man who made the trains, the mills, and the fear run on time.", scores: { stalin: 3 } },
            { label: "The orator who turned a nation into a single will.", scores: { hitler: 3, mussolini: 1 } },
            { label: "The eccentric who tried to invent a system from scratch.", scores: { gaddafi: 3 } },
            { label: "The peasant revolutionary who outlasted the cities.", scores: { mao: 3 } }
          ]
        },
        {
          text: "Your relationship to intellectuals:",
          choices: [
            { label: "Use them, then keep them nervous.", scores: { stalin: 3, mao: 1 } },
            { label: "You are one, with a pistol.", scores: { mussolini: 2, gaddafi: 2 } },
            { label: "The ones who matter already agree. The rest are noise.", scores: { hitler: 2 } },
            { label: "Send them down to learn from the people.", scores: { mao: 3 } }
          ]
        },
        {
          text: "If you had to print one object, it would be:",
          choices: [
            { label: "A green pocket constitution.", scores: { gaddafi: 3 } },
            { label: "A little red book of sayings.", scores: { mao: 3 } },
            { label: "A doorstop memoir that is also a program.", scores: { hitler: 3 } },
            { label: "Speeches. The voice is the document.", scores: { mussolini: 3, stalin: 1 } }
          ]
        }
      ],
      results: [
        { id: "gaddafi", name: "Muammar Gaddafi", years: "1942–2011", blurb: "You want a system that is neither the Politburo nor the boardroom, written in a short book you expect people to actually carry. The Green Book is the primary text. Read it as a document, not a meme.", books: ["gaddafi-s-the-green-book"] },
        { id: "mussolini", name: "Benito Mussolini", years: "1883–1945", blurb: "Politics as theater and will. The state as conductor of syndicates, crowd, and myth. His speeches are the source, not the later costume.", books: ["voce-del-popolo-mussolini-as-revealed-in-his-political-speeches", "buf-oswald-mosley-and-british-fascism"] },
        { id: "stalin", name: "Joseph Stalin", years: "1878–1953", blurb: "You think a backward country is a problem of administration: cadres, plans, and no patience for the seminar. The short book he used as a manual is still the way in.", books: ["foundations-of-leninism", "the-communism-bundle", "state-and-revolution-revised"] },
        { id: "mao", name: "Mao Zedong", years: "1893–1976", blurb: "Peasant, cadre, little book. You trust the countryside more than the ministry, and you want doctrine small enough to fit in a pocket.", books: ["little-red-book-sayings-of-chairman-mao"] },
        { id: "hitler", name: "Adolf Hitler", years: "1889–1945", blurb: "Nation, will, the long grievance turned into a program. If this is the match, read the primary texts as documents — including the ones the big retailers dropped — not as a personality quiz with a salute.", books: ["mein-kampf-complete-edition", "in-his-own-words-the-essential-speeches-of-adolf-hitler-7129", "the-man-against-time-bundle"] }
      ]
    },
    {
      id: "which-movement-would-have-disliked-you",
      handle: "which-movement-would-have-disliked-you",
      title: "Which movement would've disliked you?",
      kicker: "8 questions · 2 min",
      blurb: "The inverse quiz. Not who you are — who would have found you intolerable. Then the books from that camp, so you can hear them in their own words.",
      status: "live",
      type: "scored",
      questions: [
        {
          text: "Your honest posture toward the past is:",
          choices: [
            { label: "Most of it should be kept. The reformers are the vandals.", scores: { jacobins: 3, bolsheviks: 1 } },
            { label: "Most of it is a costume for the owners.", scores: { traditionalists: 3, fascists: 1 } },
            { label: "Burn the museums if they slow the future.", scores: { traditionalists: 2, liberals: 1 } },
            { label: "Leave me out of your restoration and your revolution.", scores: { bolsheviks: 2, fascists: 2, jacobins: 1 } }
          ]
        },
        {
          text: "You would rather be accused of:",
          choices: [
            { label: "Being insufficiently equal.", scores: { bolsheviks: 2, jacobins: 2, anarchists: 1 } },
            { label: "Being insufficiently obedient.", scores: { fascists: 3, bolsheviks: 1 } },
            { label: "Being insufficiently modern.", scores: { futurists: 3, liberals: 1 } },
            { label: "Being insufficiently spiritual.", scores: { traditionalists: 1, anarchists: 2 } }
          ]
        },
        {
          text: "Private property is:",
          choices: [
            { label: "A hill you will die on.", scores: { bolsheviks: 3, anarchists: 2 } },
            { label: "Fine, as long as the state can still point the economy.", scores: { liberals: 1, anarchists: 2 } },
            { label: "A later question. First the rite and the caste.", scores: { bolsheviks: 1, liberals: 2 } },
            { label: "A bourgeois superstition.", scores: { traditionalists: 2, fascists: 1, liberals: 2 } }
          ]
        },
        {
          text: "The nation, as a sacred object:",
          choices: [
            { label: "Makes you tired. People are not a choir.", scores: { fascists: 3, jacobins: 1 } },
            { label: "Is the only adult political unit.", scores: { anarchists: 2, bolsheviks: 1, liberals: 1 } },
            { label: "Is a stepping-stone to class, not a god.", scores: { fascists: 2, traditionalists: 1 } },
            { label: "Is downstream of a church and a people older than the state.", scores: { liberals: 2, jacobins: 2 } }
          ]
        },
        {
          text: "Speed, machines, the cult of tomorrow:",
          choices: [
            { label: "Aesthetically you love it. Morally you don't trust it.", scores: { futurists: 1, traditionalists: 1 } },
            { label: "You want more of it, immediately.", scores: { traditionalists: 3 } },
            { label: "It is how a backward country catches up. Not a poem.", scores: { futurists: 1, liberals: 1 } },
            { label: "It is a toy for people who have forgotten how to sit still.", scores: { futurists: 3 } }
          ]
        },
        {
          text: "The individual as the measure of politics:",
          choices: [
            { label: "Yes. The rest is costumes.", scores: { bolsheviks: 2, fascists: 2, traditionalists: 1 } },
            { label: "No. The unit is the class.", scores: { liberals: 2, fascists: 1, traditionalists: 1 } },
            { label: "No. The unit is the nation in uniform.", scores: { anarchists: 3, liberals: 1 } },
            { label: "No. The unit is the rite.", scores: { liberals: 2, anarchists: 1, jacobins: 1 } }
          ]
        },
        {
          text: "If a movement asked you to lie for it this week, you would:",
          choices: [
            { label: "Leave. You don't do choir practice.", scores: { bolsheviks: 2, fascists: 2, jacobins: 1 } },
            { label: "Do it if the history is large enough.", scores: { anarchists: 2, liberals: 2 } },
            { label: "Write a better lie and take over the paper.", scores: { traditionalists: 1 } },
            { label: "Ask whether the lie serves the dead as well as the living.", scores: { jacobins: 2, liberals: 1 } }
          ]
        },
        {
          text: "Pick the insult that would actually land.",
          choices: [
            { label: "Reactionary.", scores: { traditionalists: 1, fascists: 1 } },
            { label: "Bourgeois.", scores: { liberals: 2 } },
            { label: "Rootless.", scores: { anarchists: 1, liberals: 2 } },
            { label: "Priest-ridden.", scores: { traditionalists: 3, jacobins: 1 } }
          ]
        }
      ],
      results: [
        { id: "bolsheviks", name: "The Bolsheviks", blurb: "They would have called you unreliable: too fond of property, too allergic to the party, too interested in keeping a private life. If you want to hear the people who would have disliked you, start with the manuals.", books: ["state-and-revolution-revised", "foundations-of-leninism", "the-communism-bundle"] },
        { id: "traditionalists", name: "The Traditionalists", blurb: "They would have found you too modern — too impressed by the last century, too light on rite, caste, and the idea that the world has a vertical. Guénon and Evola are the indictment.", books: ["the-crisis-of-the-modern-world", "revolt-against-the-modern-world-politics-religion-and-social-order-in-the-kali-yuga", "ride-the-tiger-a-survival-manual-for-the-aristocrats-of-the-soul"] },
        { id: "anarchists", name: "The Anarchists", blurb: "You look, to them, like someone who still wants a state — a flag, a police, a plan. Goldman's essays are the case against you.", books: ["anarchism-and-other-essays"] },
        { id: "fascists", name: "The Fascists", blurb: "They would have called you a liberal, a cosmopolitan, or a man without a chest: insufficiently national, insufficiently martial, insufficiently willing to be a choir. Read the speeches as the other side of that insult.", books: ["voce-del-popolo-mussolini-as-revealed-in-his-political-speeches", "buf-oswald-mosley-and-british-fascism"] },
        { id: "jacobins", name: "The Jacobins", blurb: "You kept too much of the old world. Titles, churches, the idea that some things are not up for a vote. They would have called that treason to the year one.", books: ["what-s-wrong-with-the-world", "camp-of-the-saints"] },
        { id: "liberals", name: "The progressives", blurb: "You are the person who will not perform the decade. Too interested in limits, peoples, and books they would rather not stock. Start with the titles that argue with them in open text.", books: ["death-of-the-west-how-dying-populations-and-immigrant-invasions-imperil-our-country-and-civilization", "camp-of-the-saints", "harassment-architecture"] },
        { id: "futurists", name: "The Futurists", blurb: "You sit still. You like museums, old men, and arguments that take a century. They wanted speed, machines, and a bonfire of the libraries. Mishima and Jünger are not futurists — they are what a serious man reads instead.", books: ["sun-and-steel", "storm-of-steel-penguin-classics-deluxe-edition"] }
      ]
    }
  ]
};
